import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { createApiClient, type ApiClient } from './client';
import { createQueryClient } from './queryClient';

const ApiClientContext = createContext<ApiClient | null>(null);

export interface ApiProviderProps {
  children: ReactNode;
  /** Tests pass their own; the app uses the defaults. */
  client?: ApiClient;
  queryClient?: QueryClient;
}

export function ApiProvider({ children, client, queryClient }: ApiProviderProps) {
  const [api] = useState(() => client ?? createApiClient());
  const [queries] = useState(() => queryClient ?? createQueryClient());
  return (
    <ApiClientContext.Provider value={api}>
      <QueryClientProvider client={queries}>{children}</QueryClientProvider>
    </ApiClientContext.Provider>
  );
}

export function useApiClient(): ApiClient {
  const api = useContext(ApiClientContext);
  if (!api) throw new Error('useApiClient must be used inside <ApiProvider>');
  return api;
}
